import { companySchema } from "@/schema/Company";
import { z } from "zod";

export const companyUpdateSchema = companySchema.extend({
  industry_code: z.string(),
});

export type CompanyUpdate = z.infer<typeof companyUpdateSchema>;
